<template>
    <div v-if="filter && isActive(filter.slug) && hasFilterValues(filter.slug)"
         :class="{ active: hasSelected(filter.slug) }"
         :id="'filter-' + filter.slug">
        <div class="filter-search" v-if="filter.slug === 'brand'">
            <q-input square outlined dense v-model="brandFilter" label="Поиск">
                <template v-slot:append>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
                         viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
                        <path d="M51.816,48.904L41.788,39.09c2.546-2.883,4.101-6.635,4.101-10.744c0-9.054-7.49-16.419-16.696-16.419 c-9.206,0-16.696,7.366-16.696,16.419c0,9.053,7.49,16.418,16.696,16.418c3.574,0,6.881-1.119,9.601-3.008l10.224,10.007 c0.39,0.381,0.895,0.571,1.399,0.571c0.519,0,1.038-0.201,1.429-0.602C52.619,50.943,52.605,49.677,51.816,48.904z M15.146,28.346 c0-7.612,6.301-13.805,14.046-13.805c7.746,0,14.047,6.193,14.047,13.805c0,7.611-6.302,13.805-14.047,13.805 C21.448,42.15,15.146,35.957,15.146,28.346z"></path>
                    </svg>
                </template>
            </q-input>
        </div>
        <div v-if="!isSlider(filter.slug)" class="filter-menu-list">
            <div v-for="(value, index) in filterValues(filter.slug)"
                 class="filter-item"
                 :class="value.class">
                <div class="checkbox">
                    <input :id="filter.slug + '-' + index"
                           :disabled="!isReady"
                           :name="filter.slug + '[]'" type="checkbox"
                           @input="setOptionValue(filter.slug, {value: value.value, params: value.params})"
                           :checked="getOptionValue(filter.slug, {value: value.value, params: value.params})"/>
                    <label :for="filter.slug + '-' + index">
                        <a v-if="value.url" :href="value.url" @click.prevent="toggleOptionValue(value.value)">
                            <span class="filter-item-title">
                                <span v-if="filter.slug === 'color'" class="filter-item-color" :style="colorStyle(value.value)">
                                </span>{{ value.name }}</span>
                            <span v-if="value.count" class="filter-item-count">{{ value.count }}</span>
                        </a>
                        <span v-if="!value.url" class="filter-item-title">
                            <span v-if="filter.slug === 'color'" class="filter-item-color" :style="colorStyle(value.value)"></span>{{ value.name }}</span>
                        <span v-if="!value.url && value.count" class="filter-item-count">{{ value.count }}</span>
                    </label>
                </div>
            </div>
        </div>
        <div v-if="isSlider(filter.slug)" class="filter-range-wrapper">
                <div class="filter-range">
                    <input type="text"
                           @keypress="onlyNumber($event)"
                           :value="sliderValue(filter.slug)['min']"
                           class="filter-range-control"
                           @change="changeSliderValue(filter.slug, 'min', $event.target.value)">
                    <input type="text"
                           @keypress="onlyNumber($event)"
                           :value="sliderValue(filter.slug)['max']"
                           class="filter-range-control"
                           @change="changeSliderValue(filter.slug, 'max', $event.target.value)">
                </div>
                <q-range :value="sliderValue(filter.slug)"
                         @change="setSliderValue(filter.slug, $event)"
                         :min="rangeValue(filter.slug, 'min')"
                         :max="rangeValue(filter.slug, 'max')"
                         :step="interval(filter.slug)"
                         label/>
            </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";

export default {
    name: "Item",
    props: {
        filter: {
            type: Object
        },
    },
    data () {
        return {
            brandFilter: null
        }
    },
    watch: {
        brandFilter(value) {
            let options = this.brandOptions

            if (value) {
                options = this.brandOptions.filter((filter) => filter.name.toLowerCase().includes(value.toLowerCase()))

                if (!options.length) {
                    options = this.brandOptions
                }
            }
            this.setFilterValue({filter: 'brand', values: options})
        }
    },
    computed: {
        ...mapState('catalog', [
            'selected',
            'rangeFilters',
            'active',
            'brandOptions',
            'colors'
        ]),
        ...mapGetters('catalog', [
            'filterValues',
            'hasFilterValues',
            'getCategoryById',
            'isSlider',
            'isActive',
            'isReady'
        ]),
        optionValue: {
            get() {
                return this.selected[this.active]
                    ? this.selected[this.active]
                    : [];
            },
            set(value) {
                if (_.isEmpty(value)) {
                    Vue.delete(this.selected, this.active);
                } else {
                    Vue.set(this.selected, this.active, value);
                }
            }
        },
    },
    methods: {
        ...mapMutations('catalog', [
            'setFilterValue'
        ]),
        hasSelected(filter) {
            return this.selected[filter] && !_.isEmpty(this.selected[filter]);
        },
        setOptionValue(filter, value) {
            this.lastChanged = filter;

            if (_.isEmpty(value)) {
                Vue.delete(this.selected, filter)
            } else {
                if (!this.selected[filter]) {
                    this.$set(this.selected, filter, [])
                }
                let selected = this.selected[filter].filter(f => _.isEqual(f, value)).length

                if (selected) {
                    this.$set(this.selected, filter, this.selected[filter].filter(f => !_.isEqual(f, value)))
                } else {
                    this.selected[filter].push(value)
                }
            }
        },
        getOptionValue(filter, value) {
            return !!this.selected[filter] && this.selected[filter].filter(f => _.isEqual(f, value)).length
        },
        toggleOptionValue(value) {
            let optionValue = this.optionValue;

            let index = optionValue.indexOf(value);

            if (index !== -1) {
                optionValue.splice(index, 1);
            } else {
                optionValue.push(value);
            }

            this.optionValue = optionValue;
        },
        onlyNumber(e) {
            e = (e) ? e : window.event;
            let charCode = (e.which) ? e.which : e.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                e.preventDefault();
            } else {
                return true;
            }
        },
        getSliderValue(filter) {
            let min = parseFloat(this.rangeValue(filter, 'min')),
                max = parseFloat(this.rangeValue(filter, 'max'));

            if (this.selected[filter] && this.selected[filter]['min'] >= min) {
                min = parseFloat(this.selected[filter]['min']);
            }
            if (this.selected[filter] && this.selected[filter]['max'] <= max) {
                max = parseFloat(this.selected[filter]['max']);
            }

            return {'min': min, 'max': max};
        },
        sliderValue(slug) {
            let value = this.getSliderValue(slug);

            if (!value) {
                value = {
                    min: 0,
                    max: 0,
                }
            }
            return value;
        },
        setSliderValue(filter, value) {
            let min = value['min'],
                max = value['max'],
                minRangeValue = this.rangeValue(filter, 'min'),
                maxRangeValue = this.rangeValue(filter, 'max');

            if (min < minRangeValue) {
                min = minRangeValue;
            }

            if (max > maxRangeValue) {
                max = maxRangeValue;
            }

            if (min > max) {
                min = max;
            }

            this.$set(this.selected, filter, {min: min, max: max});

            if (min === minRangeValue && max === maxRangeValue) {
                this.$delete(this.selected, filter);
            }

            this.isSliderChanged = true;
        },
        changeSliderValue(slug, index, value) {
            let min = this.sliderValue(slug)['min'],
                max = this.sliderValue(slug)['max'];

            if (index === "min") {
                min = value
            }
            if (index === "max") {
                max = value
            }

            let newValue = {
                min, max
            }

            this.setSliderValue(slug, newValue);
        },
        rangeValue(filter, value) {
            return parseFloat(this.filterValues(filter)[value]);
        },
        interval(filter) {
            switch (filter) {
                case 'price':
                    return 100;
                    break;
                default:
                    return 1;
            }
        },
        colorStyle(id) {
            return _.get(_.find(this.colors, c => c.value === id), 'style', '')
        }
    }
}
</script>

<style scoped>

</style>
